import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-petition-update-email-limits',
		path: '/dashboard/petition_update_email_limits',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_petitionUpdateEmailLimits" */ './index'), {
			exportName: 'PetitionUpdateEmailLimits',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['campaigns', 'product', 'engineering'],
		},
		frame: true,
	},
];
